import { useUsername } from '@jotta/grpc-connect-client/customer'
import { Link } from 'react-router-dom'
import { MediaCarouselContainer } from '../../MediaCarousel/MediaCarouselContainer'
import { SelectionManager } from '../../SelectionManager/SelectionManager'
import { AlbumInfo } from '../AlbumInfo/AlbumInfo'
import { AlbumPhotosLarge } from '../AlbumPhotos/AlbumPhotosLarge'
import { AlbumPhotosSmall } from '../AlbumPhotos/AlbumPhotosSmall'
import type { AlbumInfoStore } from '../../../store/AlbumInfoStore'
import { AlbumActionHandlers } from '../AlbumInfo/AlbumActionHandlers'
import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import { Trans } from '@lingui/macro'
import SvgCaretLeft from '@jotta/ui/SvgCaretLeft'
import { observer } from 'mobx-react-lite'
import { CollectionType } from '@jotta/types/schemas/AlbumSchema'
import { AppLayoutPortal } from '@jotta/ui/AppLayoutPortal'
import { useMobileBreakpoint } from '@jotta/ui/useBreakpoint'
import { UploadPhotosButton } from '../../UploadPhotos/UploadPhotos'

function BackAction({ location }: { location: string }) {
  return (
    <Link to={location} className="btn btn-ghost flex items-center gap-2">
      <PlainBrandIcon icon={SvgCaretLeft} height={16} />
      <span>
        <Trans>Back</Trans>
      </span>
    </Link>
  )
}

export const AlbumContainer = observer<{
  album: AlbumInfoStore
  mediaId?: string
  backLocation?: string
}>(function AlbumContainer({ album, mediaId, backLocation }) {
  //TODO: kinda hard to read HTML. Create follow-up task to make more readable.
  const isMobile = useMobileBreakpoint()
  const username = useUsername()
  const photoIds = album.photoIds
  const showOwnerName = album.model.showOwnerName
  const showOwnerAvatar = album.isShared
  const showPhotos =
    album.albumType !== CollectionType.SHARED_PHOTOS || photoIds.length !== 1
  return (
    <div className="flex flex-col gap-6 p-6">
      <AlbumInfo store={album} goBig={!showPhotos} />

      {!isMobile ? (
        <>
          <AppLayoutPortal slot="moduleNav">
            <div className="flex w-full rounded-lg">
              {backLocation && <BackAction location={backLocation} />}
              <div className="grow" />
              <UploadPhotosButton btnType="GHOST" />
              <AlbumActionHandlers mediaId={mediaId} store={album} />
            </div>
          </AppLayoutPortal>
          {showPhotos && (
            <AlbumPhotosLarge ids={photoIds} ownerAvatar={showOwnerAvatar} />
          )}
        </>
      ) : (
        <>
          <AlbumActionHandlers mediaId={mediaId} store={album} />
          {showPhotos && (
            <AlbumPhotosSmall ids={photoIds} ownerAvatar={showOwnerAvatar} />
          )}
        </>
      )}

      <SelectionManager
        username={username}
        album={album.data}
        albumId={album.id}
        getDownloadInfo={album.getDownloadInfo}
        shareLink={album.shareLink}
        actionContext={album.viewContexts.selection}
        isAlbumSubscriber={album.isSubscriber}
      />
      <MediaCarouselContainer
        items={album?.photos}
        mediaId={mediaId}
        actionContext={album.viewContexts.carousel}
        showOwnerName={showOwnerName}
      />
    </div>
  )
})
